<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-sede"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import ListadoAgGridMixin from '../mixins/listado-ag-grid-mixin';
import { cellRendererNumeroRegistro } from '../utils';

export default {
  name: 'ListadoSede',
  mixins: [ListadoAgGridMixin],
  data() {
    return {
      filasSeleccionadas: [],
      columnDefs: [
        {
          headerName: '#',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'ID',
          field: 'id',
          filter: false,
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'NOMBRE',
          field: 'nombre',
          filter: false,
          minWidth: 300,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-table-sede {
  height: calc(var(--vh, 1vh) * 100 - 16rem);
}
</style>
  